export default __webpack_public_path__ + "static/media/landingLastSection.d787f1b7.png";